export const ADD_WALLET_START = 'ADD_WALLET_START';
export const ADD_WALLET_SUCCESS = 'ADD_WALLET_SUCCESS';
export const ADD_WALLET_ERROR = 'ADD_WALLET_ERROR';
export const ADD_WALLET_END = 'ADD_WALLET_END';
export const ADD_WALLET_CLEAR = 'ADD_WALLET_CLEAR';
export const DELETE_WALLET_SUCCESS = 'DELETE_WALLET_SUCCESS';
